function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import { KZUIComponent, Icon } from '@kuaizhan/kui';
import InviteModal from '../invite-modal';

var HeaderUser = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(HeaderUser, _KZUIComponent);

  var _super = _createSuper(HeaderUser);

  function HeaderUser(props) {
    var _this;

    _classCallCheck(this, HeaderUser);

    _this = _super.call(this, props);
    _this.state = {
      hideInviteModal: true
    };

    _this.autoBind('getVerificationText', 'handleClickInvite', 'handleCloseInviteModal');

    return _this;
  }

  _createClass(HeaderUser, [{
    key: "handleClickInvite",
    value: function handleClickInvite() {
      this.setState({
        hideInviteModal: false
      });
    }
  }, {
    key: "handleCloseInviteModal",
    value: function handleCloseInviteModal() {
      this.setState({
        hideInviteModal: true
      });
    }
  }, {
    key: "getVerificationText",
    value: function getVerificationText() {
      var _this$props$userInfo = this.props.userInfo,
          verificationStatus = _this$props$userInfo.verificationStatus,
          verificationType = _this$props$userInfo.verificationType,
          inWhiteList = _this$props$userInfo.inWhiteList;
      var verificationText = '未认证';

      if (verificationStatus === 2) {
        switch (verificationType) {
          case 1:
            verificationText = '个人认证';
            break;

          case 2:
            verificationText = '企业认证';
            break;

          case 3:
            verificationText = '白名单';
            break;

          case 4:
            verificationText = '机构认证';
            break;

          default:
            verificationText = '未认证';
        }
      } else if (inWhiteList) {
        verificationText = '白名单';
      }

      return verificationText;
    }
  }, {
    key: "render",
    value: function render() {
      var userName = this.props.userInfo.userName;
      var inviteCode = this.props.inviteCode;
      var hideInviteModal = this.state.hideInviteModal;
      var verificationText = this.getVerificationText();
      var mainJSX;

      if (userName) {
        mainJSX = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
          role: "button",
          tabIndex: 0,
          onClick: this.handleClickUser,
          className: "user-text"
        }, userName), /*#__PURE__*/React.createElement("div", {
          className: "user-panel"
        }, /*#__PURE__*/React.createElement("div", {
          className: "user-triangle"
        }), /*#__PURE__*/React.createElement("ul", {
          className: "user-panel-list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "user-panel-item"
        }, /*#__PURE__*/React.createElement("a", {
          href: "/user/account-settings"
        }, /*#__PURE__*/React.createElement("span", null, "\u8D26\u53F7\u8BBE\u7F6E"), /*#__PURE__*/React.createElement("span", {
          className: "user-panel-verify"
        }, verificationText))), /*#__PURE__*/React.createElement("li", {
          className: "user-panel-item"
        }, /*#__PURE__*/React.createElement("a", {
          href: "/withdraw"
        }, /*#__PURE__*/React.createElement("span", null, "\u8D26\u53F7\u94B1\u5305"))), /*#__PURE__*/React.createElement("li", {
          className: "user-panel-item"
        }, /*#__PURE__*/React.createElement("a", {
          href: "/passport/logout"
        }, /*#__PURE__*/React.createElement("span", null, "\u9000\u51FA\u767B\u5F55"))))), /*#__PURE__*/React.createElement(InviteModal, {
          hide: hideInviteModal,
          onClose: this.handleCloseInviteModal,
          inviteCode: inviteCode
        }));
      } else {
        mainJSX = /*#__PURE__*/React.createElement("a", {
          href: "/passport/login"
        }, /*#__PURE__*/React.createElement(Icon, {
          iconClass: "kz-e-user"
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "header-cell header-user"
      }, mainJSX);
    }
  }]);

  return HeaderUser;
}(KZUIComponent);

HeaderUser.defaultProps = {
  userInfo: {
    userName: '',
    verificationType: 0,
    verificationStatus: 0,
    inWhiteList: false
  },
  inviteCode: ''
};
HeaderUser.propTypes = {
  userInfo: PropTypes.shape({
    userName: PropTypes.string,
    verificationType: PropTypes.number,
    verificationStatus: PropTypes.number,
    inWhiteList: PropTypes.bool
  }),
  inviteCode: PropTypes.string
};
export default HeaderUser;